import styles from './index.module.less';
import { App, Button, Form, Input, Modal, Switch } from 'antd';
import { useUserProvider } from '@/context/UserProvider';
import { useRouter } from 'next/router';
import { useToggle } from 'react-use';
// import classNames from 'classnames';
import {
  EmailAuthProvider,
  GoogleAuthProvider,
  User,
  getAuth,
  reauthenticateWithCredential,
  sendEmailVerification,
  updatePassword,
  verifyBeforeUpdateEmail,
} from 'firebase/auth';
import { useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Cookies from 'js-cookie';
import { useConfigProvider } from '@/context/ConfigProvider';
import { isApplePrivateEmail, isEmailValid, ls_getItem } from '@/shared/utils';
import '@/lib/hooks/common/firebaseConfig/init';
import { fetchOrderSubsListRequest, emailNotification, marketEmailNotify, updateNotifationEmail } from '@/lib/service';
import { OrderInfoModel, UserInfo } from '@/types/home';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { isEmpty } from 'lodash-es';
import CommonSimpleModal from '../../Common/CommonSimpleModal';
// import PayFailModal from '@/components/PayFailModal/index';

const GeneralContent = ({
  currentUser,
  userInfo,
  updateUserInfo,
}: {
  currentUser?: User;
  userInfo?: UserInfo;
  updateUserInfo?: (info?: any) => void;
}) => {
  const { t } = useTranslation('common');
  const [form] = Form.useForm();
  const router = useRouter();
  const { onSignOut, onDeleteUser, isLogin } = useUserProvider();
  const [open, toggle] = useToggle(false);
  const [openDelete, toggleDelete] = useToggle(false);
  const [isEmail, setIsEmail] = useToggle(true);
  const [showEditNotiEmail, setShowEditNotiEmail] = useState<boolean>(false);
  const [receiveEmail, setReceiveEmail] = useState<string>(null);

  // 支付失败弹窗
  const { message } = App.useApp();
  const isSignInEmail = Cookies.get('SignInMethod') === 'email';
  // const isSignInEmail = ls_getItem('SignInMethod') === 'email';
  const [loading, setLoading] = useState(false);
  const { isBlogWeb } = useConfigProvider();

  const [orderList, setOrderList] = useState<OrderInfoModel[]>();

  const [isEmailValidsLoading, setIsEmailValidsLoading] = useState(false);
  const [isMarketEmailNotifyLoading, setIsMarketEmailNotifyLoading] = useState(false);
  const [isSendEmailLoading, setSendEmailLoading] = useState(false);
  const [lastEmailDate, setLastEmailDate] = useState<any>(null);

  // const [orderInfoModel, setOrderInfoModel] = useState<OrderInfoModel>();
  // const items = [
  //   {
  //     key: '1',
  //     label: <Link href="/billing-records">{t('PaymentHistory')}</Link>,
  //   },
  //   {
  //     key: '2',
  //     label: (
  //       <span>
  //         {selectRow?.status == 'normal' ? (
  //           <span
  //             onClick={() => {
  //               toggleUnsubscribeStop(selectRow);
  //               ga_logEvent(EventName.settings_Plan_Stop);
  //             }}
  //           >
  //             {t('StopSubscription')}
  //           </span>
  //         ) : (
  //           <span
  //             onClick={() => {
  //               onResubscribeClick(selectRow?.subs_id);
  //               ga_logEvent(EventName.settings_Plan_Subscription);
  //             }}
  //           >
  //             {t('Subscription')}
  //           </span>
  //         )}
  //       </span>
  //     ),
  //   },
  // ];

  // const loadSubList = () => {
  //   fetchOrderSubsListRequest(router.locale)
  //     .then((res) => {
  //       if (res.code === 0) {
  //         setOrderList(res?.data ?? []);
  //       } else {
  //         setOrderList([]);
  //         message.error(res?.message);
  //       }
  //     })
  //     .catch((error) => {
  //       setOrderList([]);
  //       message.error(error?.message);
  //     });
  // };

  const onEditClick = (isEmail: boolean) => {
    setIsEmail(isEmail);
    toggle(true);
  };

  const onLogoutClick = (isShowAlert?: boolean) => {
    onSignOut(isShowAlert);
    router.push('/');
  };

  const onDeleteUserClick = () => {
    toggleDelete(true);
  };

  const onDeleteFinish = () => {
    onDeleteUser();
  };

  const onFinish = (values: any) => {
    setLoading(true);
    // const accessToken = Cookies.get('accessToken');
    const accessToken = ls_getItem('accessToken');

    const credential = isSignInEmail
      ? EmailAuthProvider.credential(currentUser?.email, values?.oldPassword)
      : GoogleAuthProvider.credential(null, accessToken);

    reauthenticateWithCredential(currentUser, credential)
      .then(() => {
        if (isEmail) {
          verifyBeforeUpdateEmail(currentUser, values?.newEmail)
            .then(() => {
              message.success(t('TheVerificationEmailHasBeenSentToTheNewEmailAddress_Desc'));
              toggle(false);
              onLogoutClick(false);
              setLoading(false);
            })
            .catch((error) => {
              message.error(error.message);
              setLoading(false);
            });
        } else {
          updatePassword(currentUser, values?.password)
            .then(() => {
              toggle(false);
              message.success(t('Password update successful'));
              setLoading(false);
            })
            .catch((error) => {
              message.error(t('Password_Change_Failed_Error_Msg'));
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        message.error(t('Password_Change_Failed_Error_Msg'));
        setLoading(false);
      });
  };

  const onEmailNotification = (open: boolean) => {
    setIsEmailValidsLoading(true);
    emailNotification(open).then(() => {
      setIsEmailValidsLoading(false);
    });
  };

  const onMarketEmailNotify = (open: boolean) => {
    setIsMarketEmailNotifyLoading(true);
    marketEmailNotify(open).then(() => {
      setIsMarketEmailNotifyLoading(false);
    });
  };

  const getItem = (
    title: string | React.ReactNode,
    val: string | React.ReactNode,
    display: string,
    btnName?: string,
    onClick?: () => void,
    row?: any
  ) => {
    return (
      <div className={styles.cardContent}>
        <div style={{ width: btnName === 'switch' ? '100%' : '' }}>
          {typeof title === 'string' ? <h3>{title}</h3> : <div>{title}</div>}
          {btnName === 'switch' ? val : <span>{val}</span>}
        </div>
        {btnName !== 'switch' &&
          (btnName == '···' ? (
            <></>
          ) : btnName ? (
            <Button className={styles.rightBtn} onClick={onClick}>
              {btnName}
            </Button>
          ) : null)}
      </div>
    );
  };

  const changeValContent = () => {
    return (
      <Modal className={styles.modalContainer} open={open} onCancel={() => toggle(false)} destroyOnHidden={true}>
        <Form
          form={form}
          name="normal_edit_form"
          layout="vertical"
          className={styles.formContent}
          initialValues={{ oldEmail: currentUser?.email }}
          onFinish={onFinish}
          style={{ padding: '20px 24px' }}
        >
          <div className={styles.titleContainer}>{isEmail ? t('Change email') : t('Change password')}</div>

          {isEmail && (
            <Form.Item name="oldEmail" label={t('Current e-mail')} className="no-asterisk">
              <Input
                className={styles.inputItem}
                value={currentUser?.email}
                disabled
                // placeholder="Current e-mail"
              />
            </Form.Item>
          )}
          {isSignInEmail && (
            <Form.Item
              name="oldPassword"
              rules={[{ required: true, message: t('Please input current password') }]}
              label={t('Current password')}
              className="no-asterisk"
            >
              <Input className={styles.inputItem} type="password" />
            </Form.Item>
          )}
          {isEmail && (
            <Form.Item
              name="newEmail"
              rules={[
                { required: true, message: t('PleaseInputANewEmail') },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('oldEmail') === value || !isEmailValid(value)) {
                      return Promise.reject(new Error(t('PleaseInputANewEmail')));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              label={t('Enter new e-mail')}
              className="no-asterisk"
            >
              <Input className={styles.inputItem} />
            </Form.Item>
          )}
          {!isEmail && (
            <Form.Item
              name="password"
              rules={[{ required: true, message: t('Please input your new password') }]}
              label={t('New password')}
              className="no-asterisk"
            >
              <Input className={styles.inputItem} type="password" />
            </Form.Item>
          )}
          {!isEmail && (
            <Form.Item
              name="repassword-2"
              rules={[
                { required: true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t('theNewPasswordThatYouEnteredDoNotMatch')));
                  },
                }),
              ]}
              label={t('Confirm new password')}
              className="no-asterisk"
            >
              <Input className={styles.inputItem} type="password" />
            </Form.Item>
          )}

          <Form.Item>
            <Button type="primary" htmlType="submit" className={styles.bottomButton} loading={loading}>
              {t('Confirm')}
            </Button>
            <Button className={styles.bottomButton} onClick={() => toggle(false)}>
              {t('Cancel')}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const deleteContent = () => {
    return (
      <Modal
        className={styles.modalContainer}
        open={openDelete}
        onCancel={() => toggleDelete(false)}
        destroyOnHidden={true}
      >
        <Form
          form={form}
          name="normal_delete_form"
          layout="vertical"
          className={styles.deleteContent}
          onFinish={onDeleteFinish}
          style={{ padding: '20px 24px' }}
        >
          <div className={styles.titleContainer} style={{ textAlign: 'center' }}>
            {t('You really want to delete this account')}
          </div>

          <Form.Item>
            <p className={styles.desc}>{t('AreYouSureYouWantToPermanentlyDeleteYourAccount_Desc')}</p>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className={styles.bottomButton}>
              {t('Yes_Delete')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button className={styles.bottomButton} onClick={() => toggleDelete(false)}>
              {t('NotNow_Thanks')}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const getEmailNotiConfig = useMemo(() => {
    if (isEmpty(userInfo?.receive_email)) {
      return {
        title: t('Email notifications'),
        desc: <p>{t(`Add your email to receive updates and report notifications`)}</p>,
        cancel: t('Cancel'),
      };
    } else {
      return {
        title: t('Edit notification email'),
        desc: (
          <p>
            {t(`Current Email:`)} <span style={{ color: `#725CFF` }}>{userInfo?.receive_email}</span>.{' '}
            <span>{t(`To change your email, enter a new one below`)}</span>
          </p>
        ),
        cancel: t('Cancel'),
      };
    }
  }, [userInfo?.receive_email]);

  const onConfirmReceiveEmail = () => {
    updateNotifationEmail(receiveEmail)
      .then((res) => {
        if (res.code === 0) {
          if (isEmpty(userInfo?.receive_email)) {
            message.success(t('Success! Notification email linked'));
          } else {
            message.success(t('Email for notifications updated successfully!'));
          }
          updateUserInfo && updateUserInfo({ receive_email: receiveEmail });
          setReceiveEmail(null);
        } else {
          message.error(res?.message);
        }
      })
      .catch((error) => {
        message.error(error?.message);
      });
  };

  const onSendEmailLink = () => {
    if (isSendEmailLoading) {
      return;
    }

    const now = new Date().getTime();
    if (lastEmailDate && now - lastEmailDate < 60000) {
      // 60000ms = 1 minute
      message.error(t('Avoid frequent requests. Retry in 59s.'));
      return;
    }

    setSendEmailLoading(true);
    setLastEmailDate(now);

    const auth = getAuth();
    sendEmailVerification(auth?.currentUser, { url: process.env.NEXT_APP_WEB_HOST })
      ?.then()
      .then(() => {
        message.success(
          t('A verification email has been sent to x111x. Please check your inbox.').replace(
            'x111x',
            auth?.currentUser?.email
          )
        );
      })
      .catch((error) => {
        message.error(error?.message);
      })
      .finally(() => {
        setSendEmailLoading(false);
      });
  };

  if (isBlogWeb) {
    return <></>;
  }

  return (
    <div>
      <div className={styles.content}>
        <h2 className={styles.title}>{t('Account Details')}</h2>

        {getItem(
          t('Email'),
          currentUser?.email,
          getAuth().currentUser?.emailVerified ? 'none' : 'inline-block',
          getAuth().currentUser?.emailVerified ? null : t('Send confirm link'),
          onSendEmailLink
        )}

        {getItem(t('Password'), '******', isSignInEmail ? 'inline-block' : 'none', t('Change'), () => {
          onEditClick(false);
          ga_logEvent(EventName.settings_Password_Change);
        })}

        {/* {(orderList ?? []).map((item, index) => {
          if (item?.status != 'normal' && item?.status != 'cancel') {
            return null;
          }
          return getItem(
            t('YourPlan'),
            <>
              <div>
                {t('YouAreCurrentlyEnrolledInThe_xxx_plan').replace('xxx', `${item?.name}`)}
              </div>
              {item?.status === 'normal' ? (
                <div>{`${t('YourNextBillingDateIs')} ${item?.expire_time}`}</div>
              ) : (
                <div>{`${t('SubscriptionCancelled_AvailableBefore')} ${item?.expire_time}`}</div>
              )}
            </>,
            'inline-block',
            // item?.status === 'normal' ? t('StopSubscription') : t('Subscription'),‘
            '···',
            () => {
              if (item?.status === 'normal') {
                toggleUnsubscribeStop(item);
                ga_logEvent(EventName.settings_Plan_Stop);
              } else if (item?.status === 'cancel') {
                onResubscribeClick(item?.subs_id);
                ga_logEvent(EventName.settings_Plan_Subscription);
              }
            },
            item,
          );
        })} */}

        {getItem(
          <div className={styles.emailCardContent}>
            <div>
              <h3 style={{ fontSize: '16px', color: '#000000' }}>{t('Email notifications')}</h3>
              <span style={{ color: 'var(--app-text-60-color)' }}>
                {userInfo?.receive_email ?? t('Not yet linked')}
              </span>
            </div>

            <Button className={styles.rightBtn} onClick={() => setShowEditNotiEmail(true)}>
              {t('Change')}
            </Button>
          </div>,
          <div className={styles.switchContent}>
            <div className={styles.switchItem}>
              <span>{t('Receive news & alerts from us')}</span>
              <Switch
                loading={isEmailValidsLoading}
                checked={userInfo?.email_notify}
                onChange={(val) => {
                  if (isEmpty(userInfo?.receive_email) || isApplePrivateEmail(userInfo?.receive_email)) {
                    return message.error(t('Link your email to receive alerts'));
                  }
                  onEmailNotification(val);
                  // setUserInfo({ ...userInfo, email_notify: val });
                  updateUserInfo && updateUserInfo({ email_notify: val });
                }}
              />
            </div>
            <div className={styles.switchItem}>
              <span>{t('Receive notifications about ready reports')}</span>
              <Switch
                loading={isMarketEmailNotifyLoading}
                checked={userInfo?.market_email_notify}
                onChange={(val) => {
                  if (isEmpty(userInfo?.receive_email) || isApplePrivateEmail(userInfo?.receive_email)) {
                    return message.error(t('Link your email to receive alerts'));
                  }
                  onMarketEmailNotify(val);
                  // setUserInfo({ ...userInfo, market_email_notify: val });
                  updateUserInfo && updateUserInfo({ market_email_notify: val });
                }}
              />
            </div>
          </div>,
          '',
          'switch',
          () => {
            onEditClick(false);
            ga_logEvent(EventName.settings_Password_Change);
          }
        )}

        <div className={styles.bottomContent}>
          <Button
            className={styles.bottomBtn}
            onClick={() => {
              onLogoutClick(true);
              ga_logEvent(EventName.settings_Logout);
            }}
          >
            {t('LogOut')}
          </Button>
          <Button
            className={styles.bottomBtn}
            onClick={() => {
              onDeleteUserClick();
              ga_logEvent(EventName.settings_Delete_Account);
            }}
          >
            {t('Delete Account')}
          </Button>
        </div>
      </div>

      {changeValContent()}
      {deleteContent()}
      {/* {unsubscribeContent()}
      {unsubscribeContentStop()} */}

      {showEditNotiEmail && (
        <CommonSimpleModal
          open={showEditNotiEmail}
          title={getEmailNotiConfig?.title}
          desc={
            <div>
              {getEmailNotiConfig?.desc}
              <Input
                placeholder={t('Email')}
                style={{ marginTop: '20px', marginBottom: '30px' }}
                onChange={(e) => setReceiveEmail(e?.target?.value)}
              />
            </div>
          }
          closeBtnTitle={getEmailNotiConfig?.cancel}
          btnTitle={t('Confirm')}
          closeAction={(isOk: boolean) => {
            if (isOk) {
              if (!isEmailValid(receiveEmail)) {
                return message.error(t('Please enter a valid email address'));
              }
              onConfirmReceiveEmail();
            }
            setShowEditNotiEmail(false);
          }}
        />
      )}
    </div>
  );
};

export default GeneralContent;
